module.exports = __webpack_public_path__ + "img/no_list_data.bfd30f22.png";